import axios from "axios";
import { adaptObjectToUser } from "../models/user";

 
export function getUserMe() {
  return axios.get('/user/me', {    })
    .then((response)=> adaptObjectToUser(response?.data))
}
